import {
  Container,
  Flex,
  Box,
  Text,
  Image,
  Center,
  Skeleton,
  SkeletonText,
} from '@chakra-ui/react';
import { usePlanToken } from '../../../hooks/usePlanToken';
import logoSrc from '../../../assets/images/logo-light.png';
import SubscriptionPlanDetails from './SubscriptionPlanDetails';
import iconLightSrc from '../../../assets/images/icon-light.svg';
import TrialDetailsSubscription from './TrialDetailsSubscription';
import { HttpContext } from '../../../context/HttpContext';
import { AuthContext } from '../../../context/AuthContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { useToast } from '@chakra-ui/react';
import { CustomLogoutMultiIcon } from '../../../theme/multicolor-icons/CustomLogoutMultiIcon';
import CustomToast from '../../../common/CustomToast';
import BillingIntervalToggle from './BillingIntervalToggle';

const PlanDetailsPanel = ({
  selectedPlan,
  isTeamMemberInvitation,
  isResolvingPlan,
  selectedBillingInterval = 'year',
  onBillingIntervalChange,
}) => {
  const hasAnnualPrice =
    selectedPlan?.prices?.some((p) => p.interval === 'year') ?? false;
  const hasMonthlyPrice =
    selectedPlan?.prices?.some((p) => p.interval === 'month') ?? false;
  const showBillingIntervalToggle =
    onBillingIntervalChange &&
    (hasAnnualPrice || hasMonthlyPrice) &&
    selectedPlan?.rank !== 3;
  const { publicAxios } = useContext(HttpContext);
  const { authState, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const toast = useToast();

  const handleLogout = async () => {
    try {
      const response = await publicAxios.delete(`/accounts/sign_out`, {
        headers: {
          Authorization: `Bearer ${authState.token}`,
        },
      });
      if (response.status === 200) {
        logout();
        navigate('/login', { replace: true });
        toast({
          render: (props) => (
            <CustomToast
              status="success"
              title={response.data.message}
              description=""
              onClose={props.onClose}
            />
          ),
        });
      }
    } catch (onError) {
      toast({
        render: (props) => (
          <CustomToast
            status="error"
            title="Something went wrong"
            description="Please try again later"
            onClose={props.onClose}
          />
        ),
      });
    }
  };

  return (
    <Container
      bg="linear-gradient(180deg, #FF9554 16%, #FF6F45 55%, #FF4935 88%)"
      h="100%"
      minH="100vh"
      w="35vw"
      p={10}
      display={['none', 'none', 'none', 'block']}
    >
      <Image src={logoSrc} alt="logo" w="12vw" />
      {!isTeamMemberInvitation ? (
        <Flex justify="center" align="flex-start" pt="6vh">
          <Flex
            direction="column"
            align="center"
            justify="flex-start"
            w="85%"
            minW="300px"
            gap={5}
            position="sticky"
            top="10"
          >
            <>
              {isResolvingPlan ? (
                <Box
                  bg="white"
                  w="100%"
                  h="100%"
                  borderRadius="10px"
                  px={5}
                  py={4}
                  minW="200px"
                >
                  <Flex direction="column" gap={4}>
                    <Skeleton boxSize="50px" borderRadius="8px" />
                    <Skeleton height="28px" width="60%" />
                    <Skeleton height="20px" width="80%" />
                    <SkeletonText mt="4" noOfLines={4} spacing="3" />
                  </Flex>
                </Box>
              ) : selectedPlan?.name === 'Pilot' ||
                selectedPlan?.name === 'Launch' ? (
                <>
                  {showBillingIntervalToggle && (
                    <Flex w="100%" justify="center" mb={2}>
                      <BillingIntervalToggle
                        value={selectedBillingInterval}
                        onChange={onBillingIntervalChange}
                        gradient={false}
                        size="md"
                      />
                    </Flex>
                  )}
                  <TrialDetailsSubscription plan={selectedPlan} />
                </>
              ) : (
                <>
                  {showBillingIntervalToggle && (
                    <Flex w="100%" justify="center" mb={3}>
                      <BillingIntervalToggle
                        value={selectedBillingInterval}
                        onChange={onBillingIntervalChange}
                        size="sm"
                      />
                    </Flex>
                  )}
                  <Box
                    bg="white"
                    w="100%"
                    h="100%"
                    borderRadius="10px"
                    px={5}
                    py={4}
                    minW="200px"
                  >
                    <Text
                      textStyle="headingFamilySemiBold"
                      fontSize="26px"
                      color="#101828"
                    >
                      Free 14-day trial of:
                    </Text>
                  </Box>
                  <SubscriptionPlanDetails plan={selectedPlan} />
                </>
              )}
            </>
            <Flex
              direction="row"
              w="100%"
              mt={4}
              justifyContent="flex-start"
              alignItems="center"
              gap={2}
              cursor="pointer"
              onClick={handleLogout}
            >
              <CustomLogoutMultiIcon
                fill="#FFFFFF"
                height="23px"
                width="23px"
              />
              <Text
                textStyle="headingFamilyMedium"
                fontSize="17px"
                mt={0.5}
                color="#FFFFFF"
              >
                Log out
              </Text>
            </Flex>
          </Flex>
        </Flex>
      ) : (
        <Center h="85%">
          <Image src={iconLightSrc} alt="sign-up" w="60%" h="60%" />
        </Center>
      )}
    </Container>
  );
};

export default PlanDetailsPanel;
